import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.json.stringify.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAreaGradeInfo, userInfoComplete } from '@/api/login';
import { getCursortPosition, setCaretPosition, sleep } from '@/utils/tools';
export default {
  props: {
    noFinishInfo: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      name: '',
      gradeValue: '',
      gradeOptions: [],
      areaValue: [],
      areaOptions: []
    };
  },
  computed: {
    gradeArr: function gradeArr() {
      var _this = this;

      var obj = {};
      this.gradeOptions.forEach(function (item) {
        item.options.forEach(function (opt) {
          if (opt.value === _this.gradeValue) {
            obj.edu = item;
            obj.grade = opt;
          }
        });
      });
      return obj;
    },
    areaArr: function areaArr() {
      var _this2 = this,
          _obj$province,
          _obj$province$childre,
          _obj$city,
          _obj$city$children;

      var obj = {};
      this.areaOptions.forEach(function (item) {
        if (item.value === _this2.areaValue[0]) {
          obj.province = item;
        }
      });
      (_obj$province = obj.province) === null || _obj$province === void 0 ? void 0 : (_obj$province$childre = _obj$province.children) === null || _obj$province$childre === void 0 ? void 0 : _obj$province$childre.forEach(function (item) {
        if (item.value === _this2.areaValue[1]) {
          obj.city = item;
        }
      });
      (_obj$city = obj.city) === null || _obj$city === void 0 ? void 0 : (_obj$city$children = _obj$city.children) === null || _obj$city$children === void 0 ? void 0 : _obj$city$children.forEach(function (item) {
        if (item.value === _this2.areaValue[2]) {
          obj.area = item;
        }
      });
      return obj;
    }
  },
  watch: {
    name: function name(newValue, oldValue) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userName, cur, blankReg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userName = document.getElementById('userName');
                cur = getCursortPosition(userName);
                blankReg = /\s/gi;
                _this3.name = newValue.replace(blankReg, '');
                _context.next = 6;
                return sleep();

              case 6:
                setCaretPosition(userName, blankReg.test(oldValue) ? cur - 1 : cur);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.getAreaAndGrade();
  },
  methods: {
    getAreaAndGrade: function getAreaAndGrade() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$getAreaGradeIn, data, areaInfo, eduInfo;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getAreaGradeInfo();

              case 2:
                _yield$getAreaGradeIn = _context2.sent;
                data = _yield$getAreaGradeIn.data;
                areaInfo = data.areaInfo, eduInfo = data.eduInfo;

                _this4.dealArea(areaInfo);

                _this4.dealEdu(eduInfo);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dealArea: function dealArea(areaInfo) {
      var _this5 = this;

      var areaOptions = areaInfo.map(function (item) {
        var obj = {
          value: item.code,
          label: item.name
        }; // 处理学段key

        if (item.gradeInfo && item.gradeInfo.length > 0) {
          obj.options = _this5.dealKey(item.gradeInfo);
        } // 处理区域key


        if (item.entities && item.entities.length > 0) {
          obj.children = _this5.dealKey(item.entities);
        }

        return obj;
      });
      this.areaOptions = areaOptions;
    },
    dealEdu: function dealEdu(eduInfo) {
      var _this6 = this;

      var gradeOptions = eduInfo.map(function (item) {
        return {
          options: _this6.dealKey(item.gradeInfo),
          value: item.id,
          label: item.name
        };
      });
      this.gradeOptions = gradeOptions;
    },
    dealKey: function dealKey(arr) {
      var _this7 = this;

      return arr.map(function (item) {
        var obj = {
          value: item.id || item.code,
          label: item.name
        }; // 处理学段key

        if (item.gradeInfo && item.gradeInfo.length > 0) {
          obj.options = _this7.dealKey(item.gradeInfo);
        } // 处理区域key


        if (item.entities && item.entities.length > 0) {
          obj.children = _this7.dealKey(item.entities);
        }

        return obj;
      });
    },
    handleInfo: function handleInfo() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this8$gradeArr, _this8$gradeArr$edu, _this8$gradeArr2, _this8$gradeArr2$grad, _this8$areaArr, _this8$areaArr$provin, _this8$areaArr2, _this8$areaArr2$city, _this8$areaArr$area, _this8$gradeArr3, _this8$gradeArr3$edu, _this8$gradeArr4, _this8$gradeArr4$grad, _this8$areaArr3, _this8$areaArr3$provi, _this8$areaArr4, _this8$areaArr4$city, _this8$areaArr5, _this8$areaArr5$area;

        var params, otherInfo, _yield$userInfoComple, status, userinfo;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this8.name && !_this8.gradeValue)) {
                  _context3.next = 3;
                  break;
                }

                _this8.$message('请输入昵称，请选择年级');

                return _context3.abrupt("return");

              case 3:
                if (_this8.name) {
                  _context3.next = 6;
                  break;
                }

                _this8.$message('请输入昵称');

                return _context3.abrupt("return");

              case 6:
                if (_this8.gradeValue) {
                  _context3.next = 9;
                  break;
                }

                _this8.$message('请选择年级');

                return _context3.abrupt("return");

              case 9:
                params = {
                  name: _this8.name,
                  edu: (_this8$gradeArr = _this8.gradeArr) === null || _this8$gradeArr === void 0 ? void 0 : (_this8$gradeArr$edu = _this8$gradeArr.edu) === null || _this8$gradeArr$edu === void 0 ? void 0 : _this8$gradeArr$edu.value,
                  grade: (_this8$gradeArr2 = _this8.gradeArr) === null || _this8$gradeArr2 === void 0 ? void 0 : (_this8$gradeArr2$grad = _this8$gradeArr2.grade) === null || _this8$gradeArr2$grad === void 0 ? void 0 : _this8$gradeArr2$grad.value,
                  province: ((_this8$areaArr = _this8.areaArr) === null || _this8$areaArr === void 0 ? void 0 : (_this8$areaArr$provin = _this8$areaArr.province) === null || _this8$areaArr$provin === void 0 ? void 0 : _this8$areaArr$provin.value) || null,
                  city: ((_this8$areaArr2 = _this8.areaArr) === null || _this8$areaArr2 === void 0 ? void 0 : (_this8$areaArr2$city = _this8$areaArr2.city) === null || _this8$areaArr2$city === void 0 ? void 0 : _this8$areaArr2$city.value) || null,
                  area: ((_this8$areaArr$area = _this8.areaArr.area) === null || _this8$areaArr$area === void 0 ? void 0 : _this8$areaArr$area.value) || null
                };
                otherInfo = {
                  eduName: (_this8$gradeArr3 = _this8.gradeArr) === null || _this8$gradeArr3 === void 0 ? void 0 : (_this8$gradeArr3$edu = _this8$gradeArr3.edu) === null || _this8$gradeArr3$edu === void 0 ? void 0 : _this8$gradeArr3$edu.label,
                  gradeName: (_this8$gradeArr4 = _this8.gradeArr) === null || _this8$gradeArr4 === void 0 ? void 0 : (_this8$gradeArr4$grad = _this8$gradeArr4.grade) === null || _this8$gradeArr4$grad === void 0 ? void 0 : _this8$gradeArr4$grad.label,
                  provinceName: ((_this8$areaArr3 = _this8.areaArr) === null || _this8$areaArr3 === void 0 ? void 0 : (_this8$areaArr3$provi = _this8$areaArr3.province) === null || _this8$areaArr3$provi === void 0 ? void 0 : _this8$areaArr3$provi.label) || null,
                  cityName: ((_this8$areaArr4 = _this8.areaArr) === null || _this8$areaArr4 === void 0 ? void 0 : (_this8$areaArr4$city = _this8$areaArr4.city) === null || _this8$areaArr4$city === void 0 ? void 0 : _this8$areaArr4$city.label) || null,
                  areaName: ((_this8$areaArr5 = _this8.areaArr) === null || _this8$areaArr5 === void 0 ? void 0 : (_this8$areaArr5$area = _this8$areaArr5.area) === null || _this8$areaArr5$area === void 0 ? void 0 : _this8$areaArr5$area.label) || null,
                  avaterUrl: 'https://ucanos.xdf.cn/troy/pro/files/roc/user/avatar/default/avatar.png'
                };
                _context3.next = 13;
                return userInfoComplete(params);

              case 13:
                _yield$userInfoComple = _context3.sent;
                status = _yield$userInfoComple.status;

                if (status === 1) {
                  userinfo = _objectSpread(_objectSpread(_objectSpread({}, _this8.noFinishInfo), params), otherInfo);
                  localStorage.setItem('userInfo', JSON.stringify(userinfo)); // 体验模式下清空 默认展示完善信息的输入框

                  sessionStorage.removeItem('isPerfectInfo');

                  _this8.$router.push('/').catch(function (err) {
                    return err;
                  });
                }

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};